// extracted by mini-css-extract-plugin
module.exports = {"session_expire":"SessionExpire_session_expire__125pz"};